<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<!-- <app-footer></app-footer> -->